import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "localisation-switch-layer__head" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "localisation-switch-layer__content" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]

import {ref, onMounted, nextTick, onBeforeUnmount} from 'vue';
  import pigeon from '../../utilities/js/pigeon/pigeon';
  import SelectVue from '../select/select.vue';
  import {t} from '@/bps/utilities/js/translations/translations';
  import jsGlobalConfig from '../../globals/jsGlobalConfig';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'localisationSwitchLayer',
  props: {
    selectedCountry: {}
  },
  setup(__props: any) {

  const globalConfig = jsGlobalConfig();

  const props = __props;

  const isOpen = ref(false);
  const isLoading = ref(false);
  const localisationSwitchLayer = ref<HTMLElement | null>(null);
  const closeBtnElm = ref<HTMLElement | null>(null);
  let lastFocusedElm: HTMLElement = null;

  const model = ref({
    country: '',
    language: '',
  });

  const open = () => {
    isOpen.value = true;
    pigeon.publish('pageoverlay:show', 'page-overlay--visible-transparent');

    nextTick(() => {
      if (localisationSwitchLayer.value) {
        handleFocus(true);
      }
    });
  };

  const handleFocus = (modalActive: boolean) => {
    if (modalActive) {
      lastFocusedElm = document.activeElement as HTMLElement;
      nextTick(() => {
        localisationSwitchLayer.value.setAttribute('tabindex', '0');
        closeBtnElm.value.focus();
        localisationSwitchLayer.value.addEventListener('transitionend', () => {
          if (isOpen.value && localisationSwitchLayer.value && !localisationSwitchLayer.value.contains(document.activeElement)) {
            closeBtnElm.value.focus();
          }
        });
      });
    }
    else {
      if (lastFocusedElm) {
        nextTick(() => lastFocusedElm.focus());
      }
    }
  };

  const close = () => {
    if (isOpen.value) {
      isOpen.value = false;
      handleFocus(false);
      pigeon.publish('pageoverlay:hide', 'page-overlay--visible-transparent');
    }
  };

  const getSubmitValue = (val: string) => {
    return t(`localisation.layer.value.country.${val}`).toString();
  };

  const getCountryOptions = () => {
    const options = ['de', 'ch', 'at', 'global'];

    return options.map((key) => {
      return {
        label: t(`localisation.layer.country.${key}`),
        value: key,
        icon: `<img src="${globalConfig.getAssetPath()}/frontend-core/staticImages/country-${key}.svg" alt="${key}" class="localisation-button__flag" />`
      }
    });
  };

  const getLanguageOptions = () => {
    const options = ['de'];

    return options.map((key) => {
      return {
        label: t(`localisation.layer.language.${key}`),
        value: key
      }
    });
  };

  const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      close();
    }
  };

  onMounted(() => {
    pigeon.subscribe('localisationSwitch:open', open);
    window.addEventListener('keydown', handleKeydown);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeydown);
  });

return (_ctx: any,_cache: any) => {
  const _directive_outside_click = _resolveDirective("outside-click")!

  return (_openBlock(), _createBlock(_Transition, { name: "localisation-switch-layer-animate-top" }, {
    default: _withCtx(() => [
      (isOpen.value)
        ? _withDirectives((_openBlock(), _createElementBlock("form", {
            key: 0,
            class: "localisation-switch-layer",
            method: "get",
            action: "",
            ref_key: "localisationSwitchLayer",
            ref: localisationSwitchLayer
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createTextVNode(_toDisplayString(_ctx.$t('localisation.layer.headline')) + " ", 1 /* TEXT */),
              _createElementVNode("button", {
                class: "localisation-switch-layer__close",
                "aria-label": _ctx.$t('global.close'),
                ref_key: "closeBtnElm",
                ref: closeBtnElm,
                onClick: close,
                type: "button"
              }, null, 8 /* PROPS */, _hoisted_2)
            ]),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(SelectVue, {
                class: "localisation-switch-layer__country-select",
                modelValue: model.value.country,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.country) = $event)),
                options: getCountryOptions(),
                "initial-value": props.selectedCountry
              }, null, 8 /* PROPS */, ["modelValue", "options", "initial-value"]),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (getLanguageOptions().length > 1)
                ? (_openBlock(), _createBlock(SelectVue, {
                    key: 0,
                    class: "localisation-switch-layer__language-select",
                    modelValue: model.value.language,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.language) = $event)),
                    options: getLanguageOptions(),
                    "initial-value": model.value.language
                  }, null, 8 /* PROPS */, ["modelValue", "options", "initial-value"]))
                : _createCommentVNode("v-if", true),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createElementVNode("input", {
                type: "hidden",
                name: "geo",
                value: getSubmitValue(model.value.country)
              }, null, 8 /* PROPS */, _hoisted_4),
              _cache[4] || (_cache[4] = _createTextVNode()),
              _createElementVNode("input", {
                type: "hidden",
                name: "selectedCountry",
                value: model.value.country
              }, null, 8 /* PROPS */, _hoisted_5),
              _cache[5] || (_cache[5] = _createTextVNode()),
              (getLanguageOptions().length > 1)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "hidden",
                    name: "lang",
                    value: getSubmitValue(model.value.language)
                  }, null, 8 /* PROPS */, _hoisted_6))
                : _createCommentVNode("v-if", true),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createElementVNode("button", {
                class: _normalizeClass(["localisation-switch-layer__btn | button button--primary", {'button--loading': isLoading.value}]),
                type: "submit"
              }, _toDisplayString(_ctx.$t('localisation.layer.button.save')), 3 /* TEXT, CLASS */)
            ])
          ])), [
            [_directive_outside_click, close, true]
          ])
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})